exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".card-dashboard[data-v-152fcdb0]{min-height:220px;display:flex;justify-content:space-between;flex-direction:column;box-shadow:none!important}.card-dashboard .card-dashboard-body[data-v-152fcdb0]{display:flex;align-items:center;flex-direction:column;text-align:center;padding-bottom:0}.card-dashboard .card-dashboard-icon[data-v-152fcdb0]{width:35px;height:35px;background:#bbdefb;border-radius:50%;padding:.5rem;color:#1e88e5}", ""]);

// exports
